export const useCatalogFilterOptions = () => {
    const options = {
        type: [
            {
                value: 'all',
                name: {
                    en: "All types",
                    uk: "Всі типи",
                }
            },
            {
                value: 'company',
                name: {
                    en: "Companies",
                    uk: "Компанії",
                }
            },
            {
                value: 'user',
                name: {
                    en: "Specialists",
                    uk: "Фахівці",
                }
            }
        ],
        projectPrice: [
            {
                value: 'all',
                name: {
                    en: "Any Price",
                    uk: "Будь яка ціна",
                }
            },
            {
                value: '0-1000',
                name: {
                    en: "< $1,000/project",
                    uk: "До $1 000/проєкт",
                }
            },
            {
                value: '1000-2000',
                name: {
                    en: "$1,000 – 2,000/project",
                    uk: "$1 000 – 2 000/проєкт",
                }
            },
            {
                value: '2000-3000',
                name: {
                    en: "$2,000 – 3,000/project",
                    uk: "$2 000 – 3 000/проєкт",
                }
            },
            {
                value: '4000-5000',
                name: {
                    en: "$4,000 – 5,000/project",
                    uk: "$4 000 – 5 000/проєкт",
                }
            },
            {
                value: '5000-0',
                name: {
                    en: "> $5,000/project",
                    uk: "> $5 000/проєкт",
                }
            }
        ],
        hourPrice: [
            {
                value: 'all',
                name: {
                    en: "Any Rate",
                    uk: "Будь яка ставка",
                }
            },
            {
                value: '0-10',
                name: {
                    en: "< $10/h",
                    uk: "< $10/год",
                }
            },
            {
                value: '10-20',
                name: {
                    en: "$10 – 20/h",
                    uk: "$10 – 20/год",
                }
            },
            {
                value: '20-30',
                name: {
                    en: "$20 – 30/h",
                    uk: "$20 – 30/год",
                }
            },
            {
                value: '30-40',
                name: {
                    en: "$30 – 40/h",
                    uk: "$30 – 40/год",
                }
            },
            {
                value: '40-50',
                name: {
                    en: "$40 – 50/h",
                    uk: "$40 – 50/год",
                }
            },
            {
                value: '50-0',
                name: {
                    en: "> $50/h",
                    uk: "> $50/год",
                }
            }
        ],
        founded: [
            {
                value: 'all',
                name: {
                    "uk": "Будь-який",
                    "en": "Any"
                }
            },
            {
                value: '1-2',
                name: {
                    "uk": "1-2 роки",
                    "en": "1-2 years"
                }
            },
            {
                value: '3-5',
                name: {
                    "uk": "3-4 роки",
                    "en": "3-4 years"
                }
            },
            {
                value: '5-10',
                name: {
                    "uk": "5-9 років",
                    "en": "5-9 years"
                }
            },
            {
                value: '10-0',
                name: {
                    "uk": "10+ років",
                    "en": "10+ years"
                }
            },
        ],
        teamSize: [
            {
                value: '1–5', // startup or individual team
                name: {
                    en: '1–5 specialists',
                    uk: '1–5 фахівців'
                }
            },      
            {
                value: '6-15', // early-stage startup
                name: {
                    en: '6-15 specialists',
                    uk: '6-15 фахівців'
                }
            },     
            {
                value: '16-30', // scaling team
                name: {
                    en: '16-30 specialists',
                    uk: '16-30 фахівців'
                }
            },    
            {
                value: '31-75', // mature team
                name: {
                    en: '31-75 specialists',
                    uk: '31-75 фахівців'
                }
            },    
            {
                value: '76-150', // Dunbar’s number threshold (hard to maintain all internal connections)
                name: {
                    en: '76-150 specialists',
                    uk: '76-150 фахівців'
                }
            },   
            {
                value: '151-500', // mature business
                name: {
                    en: '151-500 specialists',
                    uk: '151-500 фахівців'
                }
            },  
            {
                value: '500+', // structured company with departments
                name: {
                    en: '500+ specialists',
                    uk: '500+  фахівців'
                }
            }      
        ] 
    }

    function getName (filter, value, locale) {
        if (!options[filter]) return null;

        let obj = options[filter].find(o => o.value == value);
        if (!obj) return null;

        return obj.name[locale];
    }

    return {
        options,
        getName
    }
}